<template>
  <component
    :is="tag"
    :class="
      `btn btn--${theme}${
        pagination ? '-' + pagination + ' btn--pagination' : ''
      }${(block && ' btn--block') || ''}`
    "
  >
    <slot />
  </component>
</template>
<script>
export default {
  props: {
    tag: {
      type: String,
      default: "a",
      validator(value) {
        return ["a", "button", "router-link", "span"].includes(value);
      }
    },
    theme: {
      type: String,
      default: "default",
      validator(value) {
        const themes = [
          "primary",
          "secondary",
          "inverted",
          "pagination",
          "default"
        ];
        return themes.includes(value);
      }
    },
    pagination: {
      type: String,
      validator(value) {
        return ["link", "elipsis"].includes(value);
      }
    },
    block: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.btn {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: variables.$fs-btn;
  text-align: center;
  text-decoration: none;
  border: none;
  border-radius: 0.1rem;
  white-space: nowrap;
  transition: all 0.2s;
  line-height: 1;
  outline: 0;
  &--block {
    display: block;
    width: 100%;
  }
  &--primary {
    cursor: pointer;
    color: variables.$primary-color;
    background: transparent;
    border: 2px solid variables.$primary-color;
    &:hover,
    &:focus,
    &.active {
      color: variables.$text-inverted-color;
      background: variables.$primary-color;
    }
  }
  &--inverted {
    cursor: pointer;
    color: variables.$text-inverted-color;
    background: variables.$background-btn-color;
    border: 2px solid variables.$border-btn-inverted-color;
    &:hover,
    &:focus {
      border: 2px solid variables.$border-btn-inverted-h-color;
      background: variables.$background-btn-inverted-color;
    }
  }
  &--pagination {
    border-radius: 50%;
    padding: 0;
    width: 32px;
    height: 32px;
    line-height: 32px;
    &-link {
      margin: 2px;
      &:hover,
      &:focus {
        color: variables.$text-inverted-color;
        background: variables.$primary-color;
      }
    }
    &.active {
      color: variables.$text-inverted-color;
      background: variables.$primary-color;
    }
  }
}
</style>
